import axios from "axios";
import { User } from "../../contexts/UserContext";
import { addLedgerNote, createAssignmentNote } from "../../reports/shared/saveLedgerAssignTo";
import { InternalUser } from "../../types/app";
import { DashboardNote } from "../types";
import { DashboardReportType } from "../../types/reports";

export const getNotes = async ({
  // selectId,
  uniqueIdentifier,
  orderNumber,
  reportType
}: {
  // selectId: number;
  uniqueIdentifier: string;
  orderNumber: string;
  reportType: DashboardReportType;
}) => {
  if (!uniqueIdentifier || !orderNumber) return;
  let { data } = await axios.get(
    `/api/outstandingchecks/getnotes?uniqueIdentifier=${uniqueIdentifier || ""}&orderNumber=${orderNumber}
    &reportType=${reportType}`
  );
  return data.sort(
    (a: DashboardNote, b: DashboardNote) =>
      new Date(b.dateCreated || "").getTime() - new Date(a.dateCreated || "").getTime()
  );
};

export const saveNote = async ({
  text,
  uniqueIdentifier,
  orderNumber,
  reportType
}: {
  text: string;
  uniqueIdentifier: string;
  orderNumber: string;
  reportType: DashboardReportType;
}) => {
  if (!uniqueIdentifier || !orderNumber || !text || !reportType) return;
  const payload = { uniqueIdentifier, orderNumber, text, reportType };
  await axios.post("/api/outstandingchecks/addnote", payload);
};

export const saveAssignToInternalUser = async ({
  user,
  uniqueIdentifier,
  orderNumber,
  reportType
}: {
  user: InternalUser | null;
  uniqueIdentifier: string;
  orderNumber?: string;
  reportType?: DashboardReportType;
}) => {
  if (!user || !uniqueIdentifier || !orderNumber) return;
  const payload = [{ uniqueIdentifier, orderNumber, name: user.fullName, email: user.email, reportType }];
  await axios.post("/api/outstandingchecks/assignTo", payload);
};

export const saveAssignToInternalUserForNonZeroLedgers = async ({
  assignToUser,
  uniqueIdentifier,
  orderNumber,
  appUser
}: {
  assignToUser: InternalUser | null;
  uniqueIdentifier: string;
  orderNumber?: string;
  appUser: User | null;
}) => {
  if (!assignToUser || !uniqueIdentifier || !orderNumber) return;
  const payload = [
    {
      uniqueIdentifier,
      orderNumber,
      name: assignToUser.fullName,
      email: assignToUser.email,
      reportType: DashboardReportType.NonZeroLedgerBalances
    }
  ];
  await axios.post("/api/outstandingchecks/AssignToWithoutNote", payload);
  const note = createAssignmentNote(assignToUser, appUser);
  await addLedgerNote(orderNumber, note);
};
